import EditorFilter from './EditorFilter'

export default EditorFilter
